import type { AccountRef, FundedWindow } from '../api/schemas';

/** Every account the organisation tracks: the funded set and the shed one
 *  together. Counting `funded_accounts` alone undercounts by every account the
 *  balance could not cover, down to zero at an empty balance. */
export function trackedAccounts(window: FundedWindow): AccountRef[] {
  return [...window.funded_accounts, ...window.shed_accounts];
}
